import React, { useState } from 'react';
import AddAgentModal from './AddAgentModal';
import Logo from './Logo';

const Navbar: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleAddAgent = (data: any) => {
        console.log('New Agent Data:', data);
        // Handle the new agent data here
    };

    return (
        <nav className="border-gray-800 mt-[-10px] md:mt-[-40px] relative z-[100]">
            {/* Header Section */}
            <div className="flex justify-between items-center mb-4 sm:mb-5 md:mb-6">
                <div className="flex justify-center items-center ">
                <Logo className="ml-[-16px] md:ml-[-32px] w-20 h-20 md:w-32 md:h-32 " />


               
                </div>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="bg-gray-200 text-black px-3 sm:px-4 md:px-6 py-1 sm:py-2 
                    rounded-lg hover:bg-gray-300 transition-all font-medium
                    text-sm sm:text-base md:text-lg relative z-[100]"
                >
                    Add Agent
                </button>
            </div>

            <AddAgentModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSubmit={handleAddAgent}
            />
        </nav>
    );
};

export default Navbar; 